import actions from "@/store/images/actions";
export default {
  actions,
  namespaced: true,
};
